import "#legacy/shared/components/wizard_modal.js";

window.ExperimentModals = {
  startExperiment: function (formHTML, pages) {
    var modal = new WizardModal({ class: "form definition-list admin-modal experiment-modal" });
    var form = jQuery(formHTML);

    // BEHAVIOUR

    var candidateCount = 1;
    var candidateNames = window.SparkleConfig.experiments.candidateIdentifiers;

    // When a new candidate fieldset is inserted, increment the counter and set the candidate name
    function addCandidate(event, candidateFields) {
      ++candidateCount;
      updateCandidateIdentifiers();

      if (candidateNames.length == candidateCount) {
        modal.container.find(".experiment-source-placeholder").hide();
      }
    }

    jQuery(modal.container).on("cocoon:after-insert", ".experiment-source-list", addCandidate);

    // When a candidate fieldset is removed, decrement the counter and set the candidate name
    function removeCandidate(event, candidateFields) {
      --candidateCount;
      updateCandidateIdentifiers();

      if (candidateNames.length > candidateCount) {
        modal.container.find(".experiment-source-placeholder").show();
      }
    }

    jQuery(modal.container).on("cocoon:after-remove", ".experiment-source-list", removeCandidate);

    // Submit the form when the user completes the wizard
    function submitExperiment() {
      form.appendTo("body").append(modal.container)[0].submit(); // Submit undecorated form to ignore HTML5 validation
    }

    jQuery(modal).on("beforeComplete", submitExperiment);

    // HELPER FUNCTIONS
    function updateCandidateIdentifiers() {
      jQuery(modal.container)
        .find(".source-identifier")
        .each(function (index) {
          jQuery(this).html(candidateNames[index]);
        });
    }

    // INITIALIZE

    jQuery(pages).each(function () {
      modal.addPage(this);
    });
    modal.container.addClass("modal-medium"); // TODO: Find a better way to add classes to modals

    return modal;
  },

  endExperiment: function (formHTML, pages) {
    var modal = new WizardModal({
      cancelText: "Continue Experiment",
      completeText: "Complete Experiment",
    });
    var form = jQuery(formHTML);

    // BEHAVIOUR

    jQuery(modal).on("beforePageShow", resetChoices);
    jQuery(modal).on("pageShow", disableSubmit);

    // When an option is clicked, mark it as the winner
    function selectWinner() {
      jQuery(this).find("[data-behaviour=experiment-winner-indicator]").prop("checked", true);
      enableSubmit();
    }

    jQuery(modal.container).on("click", "[data-behaviour=experiment-winner-option]", selectWinner);

    // Submit the form when the user completes the wizard
    function submitExperimentResult() {
      form.appendTo("body").append(modal.container).trigger("submit");
    }

    jQuery(modal).on("beforeComplete", submitExperimentResult);

    // HELPER FUNCTIONS

    function resetChoices() {
      jQuery(modal.container).find("[data-behaviour=experiment-winner-indicator]").prop("checked", false);
    }

    function enableSubmit() {
      jQuery(modal.container)
        .find('[data-behaviour="complete-modal"]')
        .removeClass("disabled")
        .off("click", cancelClick);
    }

    function disableSubmit() {
      jQuery(modal.container).find('[data-behaviour="complete-modal"]').addClass("disabled").on("click", cancelClick);
    }

    function cancelClick(event) {
      return false;
    }

    // INITIALIZE

    jQuery(pages).each(function () {
      modal.addPage(this);
    });
    modal.container.addClass("modal-medium"); // TODO: Find a better way to add classes to modals

    return modal;
  },
};

const ExperimentMenuAction = Object.freeze({
  START: "start-experiment",
  COMPLETE: "complete-experiment",
});

function runExperimentMenuAction(event) {
  const item = event.target.closest(
    `sp-button[data-behaviour~="${ExperimentMenuAction.START}"], sp-button[data-behaviour~="${ExperimentMenuAction.COMPLETE}"]`,
  );

  if (!item || item.matches(":disabled")) {
    return;
  }

  const modals = {
    [ExperimentMenuAction.START]: window.startExperimentModal,
    [ExperimentMenuAction.COMPLETE]: window.endExperimentModal,
  };
  const action = item.dataset.behaviour.split(/\s+/).find((name) => Object.hasOwn(modals, name));
  const modal = modals[action];

  if (modal) {
    event.preventDefault();
    modal.showPage(1);
  }
}

document.addEventListener("click", runExperimentMenuAction);
